define("shared/components/shared/post/secondary/caption-writer", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/object/computed", "@ember/runloop", "@ember/service", "@ember/utils", "@glimmer/component", "ember-changeset", "ember-changeset-validations", "ember-concurrency", "moment", "tracked-built-ins", "later/utils/constants/segment-events", "later/utils/fetch", "shared/utils/caption-writer/format-tone-for-segment", "shared/utils/retry", "shared/validations/generated-caption", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _object, _computed, _runloop, _service, _utils, _component2, _emberChangeset, _emberChangesetValidations, _emberConcurrency, _moment, _trackedBuiltIns, _segmentEvents, _fetch, _formatToneForSegment, _retry, _generatedCaption, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _captionIsEmpty, _displayPreviouslyGeneratedCaptions, _displayStillLoadingAlert, _displayUsageAlert, _instantiateAssociations, _manuallyCheckCaptions, _onFirstCaptionGenerated, _reloadCaptionsOnTimeout, _setManualFailure, _setupFayeListener, _teardownFayeListener, _onFayeUpdateCaption, _trackAiGenerationTimeouts;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/object/computed",0,"@ember/runloop",0,"@ember/service",0,"@ember/utils",0,"@embroider/macros",0,"@glimmer/component",0,"ember-changeset",0,"ember-changeset-validations",0,"ember-concurrency",0,"moment",0,"tracked-built-ins",0,"later/utils/constants/segment-events",0,"later/utils/fetch",0,"shared/utils/caption-writer/format-tone-for-segment",0,"shared/utils/retry",0,"shared/validations/generated-caption",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }
  function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateMethodGet(receiver, privateSet, fn) { _assertClassBrand(privateSet, receiver); return fn; }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div
    class="o--modalCard--secondary tCW--modalCard"
    data-test-id="caption-writer"
    {{did-insert this.onInsertComponent}}
    {{did-update this.captionUpdated @post.caption}}
  >
    {{#if this.isLoading}}
      <Shared::Post::Secondary::CaptionWriter::Loader />
    {{else}}
      <Shared::Post::Secondary::CaptionWriter::Header
        @creditCountForPlan={{this.creditCountForPlan}}
        @displayInfoModal={{this.displayInfoModal}}
        @enableFormVisibility={{fn this.setFormVisibility true}}
        @isFormHidden={{this.isFormHidden}}
        @isFreeOrLegacyUser={{this.isFreeOrLegacyUser}}
        @navigateBack={{this.handleNavigateBack}}
        @navigationState={{this.navigationState}}
        @nextCreditUpdate={{this.nextCreditUpdate}}
        @onSeamlessCheckoutSuccess={{this.onSeamlessCheckoutSuccess}}
        @remainingCaptionGenerationUsages={{this.remainingCaptionGenerationUsages}}
        @shouldDisplayCreditPurchase={{this.displayCreditPurchase}}
        @shouldDisplayNoRemainingCaptions={{this.shouldDisplayNoRemainingCaptions}}
        @showCreditPurchase={{fn this.setDisplayCreditPurchase true}}
        @showCreditsDescription={{this.showCreditsDescription}}
        @toggleCaptionWriterModal={{@toggle}}
        @toggleInfoModal={{this.toggleInfoModal}}
      />
  
      <div
        data-test-id="caption-writer-body"
        class={{concat-classes
          "o--modalBody--secondary"
          "tCW--modalBody"
          (if this.isBannerVisibleInHeader "tCW--modalBody--withBanner")
          "has--scroll"
        }}
        ...attributes
        {{perfect-scroll}}
      >
        {{#if this.shouldDisplayCreditPurchase}}
          <Shared::Post::Secondary::CaptionWriter::CreditPurchase
            @creditUsage={{t
              "caption_writer.usage_warning.counter"
              creditsForPlan=this.creditCountForPlan
              remainingCredits=this.remainingCaptionGenerationUsages
            }}
            @hideCreditPurchase={{fn this.setDisplayCreditPurchase false}}
            @nextCreditUpdate={{this.nextCreditUpdate}}
            @onSeamlessCheckoutSuccess={{this.onSeamlessCheckoutSuccess}}
            @subscriptionPlans={{this.subscriptionPlans}}
          />
        {{else}}
          {{#if this.showLandingCard}}
            <Shared::Post::Secondary::CaptionWriter::LandingCard
              {{! TODO: Move these conditionals somewhere easy to read }}
              @isChangeToneDisabled={{or
                this.isGeneratingCaptions
                (not this.postCaptionHasText)
                (eq this.remainingCaptionGenerationUsages 0)
              }}
              @isGenerateNewDisabled={{or this.isGeneratingCaptions (eq this.remainingCaptionGenerationUsages 0)}}
              @isRephraseDisabled={{or
                this.isGeneratingCaptions
                (not this.postCaptionHasText)
                (eq this.remainingCaptionGenerationUsages 0)
              }}
              @onChangeTone={{this.onChangeTone}}
              @onGenerateNew={{this.onGenerateNew}}
              @onRephrase={{this.onRephrase}}
            />
          {{else if (not this.isFormHidden)}}
            {{! TODO: We need to split up this form component instead of using `onlyTone` flag }}
            <Shared::Post::Secondary::CaptionWriter::Form
              @disabled={{this.isFormDisabled}}
              @generateCaptions={{this.generateCaptions}}
              @generatedCaptionChangeset={{this.generatedCaptionChangeset}}
              @isGeneratingCaptions={{this.isGeneratingCaptions}}
              @skipTopic={{this.isChangingToneOfCaption}}
            />
          {{/if}}
          {{#if this.hasError}}
            <Shared::Ui::FlashMessage
              @close={{fn this.setHasDefaultError false}}
              @flash={{this.errorObject}}
              class="u--m"
              data-test-id="caption-writer-flash-error"
            />
          {{else}}
            {{#if this.showCaptionHistorySection}}
              <hr class="u--m__t__lg u--m__b" />
              <p class="u--text--bold u--m__lr">
                {{svg-jar "history" class="o--icon u--m__r__xs"}}
                {{t "caption_writer.caption_history"}}
              </p>
            {{/if}}
            <Shared::Post::Secondary::CaptionWriter::List
              @displayedCaptionIds={{this.displayedCaptionIds}}
              @generatedCaptions={{this.sortedGeneratedCaptions}}
              @hideGeneratedCaption={{this.hideGeneratedCaption}}
              @isChangingToneOfCaption={{this.isChangingToneOfCaption}}
              @mediaItem={{@mediaItem}}
              @onCaptionRefinement={{this.refineCaption}}
              @post={{@post}}
              @postElementId={{@postElementId}}
              @shouldDisplayNoRemainingCaptions={{eq this.remainingCaptionGenerationUsages 0}}
              @showCreditPurchase={{fn this.setDisplayCreditPurchase true}}
            />
          {{/if}}
        {{/if}}
      </div>
  
      <Shared::Post::Secondary::CaptionWriter::Footer
        @creditCountForPlan={{this.creditCountForPlan}}
        @hideCreditPurchase={{fn this.setDisplayCreditPurchase false}}
        @isEnterpriseSubscription={{this.isEnterpriseSubscription}}
        @remainingCaptionGenerationUsages={{this.remainingCaptionGenerationUsages}}
        @shouldDisplayCreditPurchase={{this.shouldDisplayCreditPurchase}}
        @showCreditPurchase={{fn this.setDisplayCreditPurchase true}}
      />
  
    {{/if}}
  </div>
  
  {{#if (and (not this.isLoading) this.displayDisclaimer)}}
    <Shared::Portal @destinationElement="root-portal">
      <Shared::Post::Secondary::CaptionWriter::Disclaimer
        @closeModal={{this.closeDisclaimer}}
        @submitDisclaimer={{this.submitDisclaimer}}
      />
    </Shared::Portal>
  {{/if}}
  */
  {
    "id": "xQnYYDuK",
    "block": "[[[11,0],[24,0,\"o--modalCard--secondary tCW--modalCard\"],[24,\"data-test-id\",\"caption-writer\"],[4,[38,0],[[30,0,[\"onInsertComponent\"]]],null],[4,[38,1],[[30,0,[\"captionUpdated\"]],[30,1,[\"caption\"]]],null],[12],[1,\"\\n\"],[41,[30,0,[\"isLoading\"]],[[[1,\"    \"],[8,[39,3],null,null,null],[1,\"\\n\"]],[]],[[[1,\"    \"],[8,[39,4],null,[[\"@creditCountForPlan\",\"@displayInfoModal\",\"@enableFormVisibility\",\"@isFormHidden\",\"@isFreeOrLegacyUser\",\"@navigateBack\",\"@navigationState\",\"@nextCreditUpdate\",\"@onSeamlessCheckoutSuccess\",\"@remainingCaptionGenerationUsages\",\"@shouldDisplayCreditPurchase\",\"@shouldDisplayNoRemainingCaptions\",\"@showCreditPurchase\",\"@showCreditsDescription\",\"@toggleCaptionWriterModal\",\"@toggleInfoModal\"],[[30,0,[\"creditCountForPlan\"]],[30,0,[\"displayInfoModal\"]],[28,[37,5],[[30,0,[\"setFormVisibility\"]],true],null],[30,0,[\"isFormHidden\"]],[30,0,[\"isFreeOrLegacyUser\"]],[30,0,[\"handleNavigateBack\"]],[30,0,[\"navigationState\"]],[30,0,[\"nextCreditUpdate\"]],[30,0,[\"onSeamlessCheckoutSuccess\"]],[30,0,[\"remainingCaptionGenerationUsages\"]],[30,0,[\"displayCreditPurchase\"]],[30,0,[\"shouldDisplayNoRemainingCaptions\"]],[28,[37,5],[[30,0,[\"setDisplayCreditPurchase\"]],true],null],[30,0,[\"showCreditsDescription\"]],[30,2],[30,0,[\"toggleInfoModal\"]]]],null],[1,\"\\n\\n    \"],[11,0],[24,\"data-test-id\",\"caption-writer-body\"],[16,0,[28,[37,6],[\"o--modalBody--secondary\",\"tCW--modalBody\",[52,[30,0,[\"isBannerVisibleInHeader\"]],\"tCW--modalBody--withBanner\"],\"has--scroll\"],null]],[17,3],[4,[38,7],null,null],[12],[1,\"\\n\"],[41,[30,0,[\"shouldDisplayCreditPurchase\"]],[[[1,\"        \"],[8,[39,8],null,[[\"@creditUsage\",\"@hideCreditPurchase\",\"@nextCreditUpdate\",\"@onSeamlessCheckoutSuccess\",\"@subscriptionPlans\"],[[28,[37,9],[\"caption_writer.usage_warning.counter\"],[[\"creditsForPlan\",\"remainingCredits\"],[[30,0,[\"creditCountForPlan\"]],[30,0,[\"remainingCaptionGenerationUsages\"]]]]],[28,[37,5],[[30,0,[\"setDisplayCreditPurchase\"]],false],null],[30,0,[\"nextCreditUpdate\"]],[30,0,[\"onSeamlessCheckoutSuccess\"]],[30,0,[\"subscriptionPlans\"]]]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"showLandingCard\"]],[[[1,\"          \"],[8,[39,10],null,[[\"@isChangeToneDisabled\",\"@isGenerateNewDisabled\",\"@isRephraseDisabled\",\"@onChangeTone\",\"@onGenerateNew\",\"@onRephrase\"],[[28,[37,11],[[30,0,[\"isGeneratingCaptions\"]],[28,[37,12],[[30,0,[\"postCaptionHasText\"]]],null],[28,[37,13],[[30,0,[\"remainingCaptionGenerationUsages\"]],0],null]],null],[28,[37,11],[[30,0,[\"isGeneratingCaptions\"]],[28,[37,13],[[30,0,[\"remainingCaptionGenerationUsages\"]],0],null]],null],[28,[37,11],[[30,0,[\"isGeneratingCaptions\"]],[28,[37,12],[[30,0,[\"postCaptionHasText\"]]],null],[28,[37,13],[[30,0,[\"remainingCaptionGenerationUsages\"]],0],null]],null],[30,0,[\"onChangeTone\"]],[30,0,[\"onGenerateNew\"]],[30,0,[\"onRephrase\"]]]],null],[1,\"\\n\"]],[]],[[[41,[28,[37,12],[[30,0,[\"isFormHidden\"]]],null],[[[1,\"          \"],[8,[39,14],null,[[\"@disabled\",\"@generateCaptions\",\"@generatedCaptionChangeset\",\"@isGeneratingCaptions\",\"@skipTopic\"],[[30,0,[\"isFormDisabled\"]],[30,0,[\"generateCaptions\"]],[30,0,[\"generatedCaptionChangeset\"]],[30,0,[\"isGeneratingCaptions\"]],[30,0,[\"isChangingToneOfCaption\"]]]],null],[1,\"\\n        \"]],[]],null]],[]]],[41,[30,0,[\"hasError\"]],[[[1,\"          \"],[8,[39,15],[[24,0,\"u--m\"],[24,\"data-test-id\",\"caption-writer-flash-error\"]],[[\"@close\",\"@flash\"],[[28,[37,5],[[30,0,[\"setHasDefaultError\"]],false],null],[30,0,[\"errorObject\"]]]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"showCaptionHistorySection\"]],[[[1,\"            \"],[10,\"hr\"],[14,0,\"u--m__t__lg u--m__b\"],[12],[13],[1,\"\\n            \"],[10,2],[14,0,\"u--text--bold u--m__lr\"],[12],[1,\"\\n              \"],[1,[28,[35,16],[\"history\"],[[\"class\"],[\"o--icon u--m__r__xs\"]]]],[1,\"\\n              \"],[1,[28,[35,9],[\"caption_writer.caption_history\"],null]],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],null],[1,\"          \"],[8,[39,17],null,[[\"@displayedCaptionIds\",\"@generatedCaptions\",\"@hideGeneratedCaption\",\"@isChangingToneOfCaption\",\"@mediaItem\",\"@onCaptionRefinement\",\"@post\",\"@postElementId\",\"@shouldDisplayNoRemainingCaptions\",\"@showCreditPurchase\"],[[30,0,[\"displayedCaptionIds\"]],[30,0,[\"sortedGeneratedCaptions\"]],[30,0,[\"hideGeneratedCaption\"]],[30,0,[\"isChangingToneOfCaption\"]],[30,4],[30,0,[\"refineCaption\"]],[30,1],[30,5],[28,[37,13],[[30,0,[\"remainingCaptionGenerationUsages\"]],0],null],[28,[37,5],[[30,0,[\"setDisplayCreditPurchase\"]],true],null]]],null],[1,\"\\n\"]],[]]]],[]]],[1,\"    \"],[13],[1,\"\\n\\n    \"],[8,[39,18],null,[[\"@creditCountForPlan\",\"@hideCreditPurchase\",\"@isEnterpriseSubscription\",\"@remainingCaptionGenerationUsages\",\"@shouldDisplayCreditPurchase\",\"@showCreditPurchase\"],[[30,0,[\"creditCountForPlan\"]],[28,[37,5],[[30,0,[\"setDisplayCreditPurchase\"]],false],null],[30,0,[\"isEnterpriseSubscription\"]],[30,0,[\"remainingCaptionGenerationUsages\"]],[30,0,[\"shouldDisplayCreditPurchase\"]],[28,[37,5],[[30,0,[\"setDisplayCreditPurchase\"]],true],null]]],null],[1,\"\\n\\n\"]],[]]],[13],[1,\"\\n\\n\"],[41,[28,[37,19],[[28,[37,12],[[30,0,[\"isLoading\"]]],null],[30,0,[\"displayDisclaimer\"]]],null],[[[1,\"  \"],[8,[39,20],null,[[\"@destinationElement\"],[\"root-portal\"]],[[\"default\"],[[[[1,\"\\n    \"],[8,[39,21],null,[[\"@closeModal\",\"@submitDisclaimer\"],[[30,0,[\"closeDisclaimer\"]],[30,0,[\"submitDisclaimer\"]]]],null],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[]],null]],[\"@post\",\"@toggle\",\"&attrs\",\"@mediaItem\",\"@postElementId\"],false,[\"did-insert\",\"did-update\",\"if\",\"shared/post/secondary/caption-writer/loader\",\"shared/post/secondary/caption-writer/header\",\"fn\",\"concat-classes\",\"perfect-scroll\",\"shared/post/secondary/caption-writer/credit-purchase\",\"t\",\"shared/post/secondary/caption-writer/landing-card\",\"or\",\"not\",\"eq\",\"shared/post/secondary/caption-writer/form\",\"shared/ui/flash-message\",\"svg-jar\",\"shared/post/secondary/caption-writer/list\",\"shared/post/secondary/caption-writer/footer\",\"and\",\"shared/portal\",\"shared/post/secondary/caption-writer/disclaimer\"]]",
    "moduleName": "shared/components/shared/post/secondary/caption-writer.hbs",
    "isStrictMode": false
  });

  // TODO: When there's more time, it would be worthwhile to dig into the typing coming from ember-changeset
  // to see if we can avoid some of the casting and manual typing here

  const CLICKED_GENERATE_CAPTIONS_SEGMENT_EVENT = 'clicked-generate-ai-captions-button';
  const GENERATED_CAPTIONS_SEGMENT_EVENT = 'generated-ai-captions';
  const OPENED_CAPTION_WRITER_SEGMENT_EVENT = 'opened-ai-caption-writer';
  const UPDATE_GENERATED_CAPTION_FAYE_EVENT = 'generatedCaptionUpdate';
  let CaptionWriterComponent = _exports.default = (_dec = (0, _computed.sort)('generatedCaptions', 'captionSorting'), _dec2 = (0, _object.computed)('generatedCaptions.[]'), (_class = (_captionIsEmpty = /*#__PURE__*/new WeakSet(), _displayPreviouslyGeneratedCaptions = /*#__PURE__*/new WeakSet(), _displayStillLoadingAlert = /*#__PURE__*/new WeakSet(), _displayUsageAlert = /*#__PURE__*/new WeakSet(), _instantiateAssociations = /*#__PURE__*/new WeakSet(), _manuallyCheckCaptions = /*#__PURE__*/new WeakSet(), _onFirstCaptionGenerated = /*#__PURE__*/new WeakSet(), _reloadCaptionsOnTimeout = /*#__PURE__*/new WeakSet(), _setManualFailure = /*#__PURE__*/new WeakSet(), _setupFayeListener = /*#__PURE__*/new WeakSet(), _teardownFayeListener = /*#__PURE__*/new WeakSet(), _onFayeUpdateCaption = /*#__PURE__*/new WeakSet(), _trackAiGenerationTimeouts = /*#__PURE__*/new WeakSet(), class CaptionWriterComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _classPrivateMethodInitSpec(this, _trackAiGenerationTimeouts);
      _classPrivateMethodInitSpec(this, _onFayeUpdateCaption);
      _classPrivateMethodInitSpec(this, _teardownFayeListener);
      _classPrivateMethodInitSpec(this, _setupFayeListener);
      _classPrivateMethodInitSpec(this, _setManualFailure);
      _classPrivateMethodInitSpec(this, _reloadCaptionsOnTimeout);
      _classPrivateMethodInitSpec(this, _onFirstCaptionGenerated);
      _classPrivateMethodInitSpec(this, _manuallyCheckCaptions);
      // Note: Associates the post and generatedCaption, although this won't be persisted until the post is
      // saved in app/services/schedule/post.ts
      _classPrivateMethodInitSpec(this, _instantiateAssociations);
      _classPrivateMethodInitSpec(this, _displayUsageAlert);
      _classPrivateMethodInitSpec(this, _displayStillLoadingAlert);
      _classPrivateMethodInitSpec(this, _displayPreviouslyGeneratedCaptions);
      _classPrivateMethodInitSpec(this, _captionIsEmpty);
      _initializerDefineProperty(this, "aiCredits", _descriptor, this);
      _initializerDefineProperty(this, "alerts", _descriptor2, this);
      _initializerDefineProperty(this, "auth", _descriptor3, this);
      _initializerDefineProperty(this, "cache", _descriptor4, this);
      _initializerDefineProperty(this, "errors", _descriptor5, this);
      _initializerDefineProperty(this, "faye", _descriptor6, this);
      _initializerDefineProperty(this, "intl", _descriptor7, this);
      _initializerDefineProperty(this, "locale", _descriptor8, this);
      _initializerDefineProperty(this, "router", _descriptor9, this);
      _initializerDefineProperty(this, "segment", _descriptor10, this);
      _initializerDefineProperty(this, "subscriptions", _descriptor11, this);
      _initializerDefineProperty(this, "store", _descriptor12, this);
      _defineProperty(this, "generatedCaptionChangeset", void 0);
      _defineProperty(this, "captionSorting", ['createdAt:asc']);
      _defineProperty(this, "timers", []);
      _initializerDefineProperty(this, "displayedCaptionIds", _descriptor13, this);
      _initializerDefineProperty(this, "displayCreditPurchase", _descriptor14, this);
      _initializerDefineProperty(this, "displayDisclaimer", _descriptor15, this);
      _initializerDefineProperty(this, "displayInfoModal", _descriptor16, this);
      _initializerDefineProperty(this, "formDisabled", _descriptor17, this);
      _initializerDefineProperty(this, "isChangingToneOfCaption", _descriptor18, this);
      _initializerDefineProperty(this, "isFormHidden", _descriptor19, this);
      _initializerDefineProperty(this, "hasDefaultError", _descriptor20, this);
      _initializerDefineProperty(this, "hasAcknowledgedNoCredits", _descriptor21, this);
      _initializerDefineProperty(this, "manualFailure", _descriptor22, this);
      _initializerDefineProperty(this, "isLoading", _descriptor23, this);
      _initializerDefineProperty(this, "navigationState", _descriptor24, this);
      _initializerDefineProperty(this, "sortedGeneratedCaptions", _descriptor25, this);
      _defineProperty(this, "refineCaption", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function (_ref) {
          var _this = this;
          let {
            generatedCaption,
            type,
            value,
            groupTone,
            targetPostCaptionText
          } = _ref;
          return function* () {
            const isRephrase = type === 'rephrase';
            const tone = isRephrase ? groupTone : value;
            const source = type === 'rephrase' ? 'generated-from-rephrasing' : 'generated-from-tone-change';
            _this.manualFailure = false;
            _this.formDisabled = true;
            _this.segment.track(CLICKED_GENERATE_CAPTIONS_SEGMENT_EVENT, {
              ..._this.defaultSegmentAttributes,
              source,
              tone: (0, _formatToneForSegment.default)(tone),
              refinement_applied_to: targetPostCaptionText ? 'post-caption-text' : 'later-generated-caption'
            });
            _classPrivateMethodGet(_this, _reloadCaptionsOnTimeout, _reloadCaptionsOnTimeout2).call(_this, 10000);
            _classPrivateMethodGet(_this, _reloadCaptionsOnTimeout, _reloadCaptionsOnTimeout2).call(_this, 20000);
            _classPrivateMethodGet(_this, _setManualFailure, _setManualFailure2).call(_this, 21000);
            if (!_this.remainingCaptionGenerationUsages) {
              return _classPrivateMethodGet(_this, _displayUsageAlert, _displayUsageAlert2).call(_this);
            }
            try {
              const response = yield generatedCaption.refine({
                social_profile_id: _this.args.socialProfile.get('id'),
                change: isRephrase ? 'rephrase' : 'tone',
                change_parameters: isRephrase ? undefined : {
                  tone: String(value)
                }
              });
              if (response.errors?.length) {
                throw response.errors;
              }
              if (!response.generated_captions) {
                throw new Error('No refined captions returned in response');
              }
              _this._processCaptionGeneration.linked().perform(response.generated_captions);
            } catch (error) {
              _this.setHasDefaultError(true);
              _this.errors.log('refineCaption Error: ', error);
            }
          }();
        }
      }), {
        restartable: true
      }, "refineCaption", null));
      _defineProperty(this, "generateCaptions", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          const tone = this.generatedCaptionChangeset?.tone;
          const topic = this.generatedCaptionChangeset?.topic;
          const targetPostCaptionText = this.generatedCaptionChangeset?.targetPostCaptionText;

          // TODO: this is hacky
          // Note: we're actually refining rather than generating - pass onto refinement task
          if (this.navigationState.current === 'change-tone') {
            const temporaryGeneratedCaption = this.store.createRecord('generated-caption', {
              generatedText: topic
            });
            yield this.refineCaption.linked().perform({
              generatedCaption: temporaryGeneratedCaption,
              type: 'tone',
              value: tone,
              targetPostCaptionText
            });
            temporaryGeneratedCaption.unloadRecord();
            this.updateNavigationState('change-tone.list');
            return;
          }
          this.manualFailure = false;
          this.formDisabled = true;
          this.segment.track(CLICKED_GENERATE_CAPTIONS_SEGMENT_EVENT, {
            ...this.defaultSegmentAttributes,
            source: 'generated-from-scratch',
            tone: (0, _formatToneForSegment.default)(tone)
          });
          _classPrivateMethodGet(this, _reloadCaptionsOnTimeout, _reloadCaptionsOnTimeout2).call(this, 10000);
          _classPrivateMethodGet(this, _reloadCaptionsOnTimeout, _reloadCaptionsOnTimeout2).call(this, 20000);
          _classPrivateMethodGet(this, _setManualFailure, _setManualFailure2).call(this, 21000);
          if (!this.remainingCaptionGenerationUsages) {
            return _classPrivateMethodGet(this, _displayUsageAlert, _displayUsageAlert2).call(this);
          }
          try {
            const response = yield this._fetchGeneratedCaptions.linked().perform({
              topic: topic.toLowerCase(),
              tone
            });
            if (response.errors?.length) {
              throw response.errors;
            }
            if (!response.generated_captions) {
              throw new Error('No generated captions returned in response');
            }
            yield this._processCaptionGeneration.linked().perform(response.generated_captions);
          } catch (error) {
            this.setHasDefaultError(true);
            this.errors.log('generateCaptions Error: ', error);
          }
        }
      }), {
        restartable: true
      }, "generateCaptions", null));
      _defineProperty(this, "submitDisclaimer", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          try {
            yield (0, _fetch.fetch)('api/v2/generated_captions/accept.json', {
              method: 'POST'
            }, {
              intl: null,
              numRetries: 3,
              retryStrategy: _retry.STRATEGY.DEFAULT,
              raw: true
            });
          } catch (error) {
            this.errors.log('submitDisclaimer Error', error);
          }
          this.displayDisclaimer = false;
        }
      }), null, "submitDisclaimer", null));
      _defineProperty(this, "fetchDisclaimerStatus", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          try {
            if (this.cache.retrieve(this.cacheKey)) {
              this.displayDisclaimer = false;
              return;
            }
            const response = yield (0, _fetch.fetch)('/api/v2/generated_captions/disclaimer_accepted.json', {
              method: 'GET'
            });
            if ((0, _utils.isPresent)(response.disclaimer_accepted_at)) {
              this.displayDisclaimer = false;
              this.cache.add(this.cacheKey, true, {
                expiry: this.cache.maxExpiryDate(),
                persist: true
              });
            } else if (this.isFreeOrLegacyUserWithoutCredits) {
              this.displayDisclaimer = false;
            } else {
              this.displayDisclaimer = true;
            }
          } catch (error) {
            this.errors.log('fetchDisclaimerStatus Error', error);
          }
        }
      }), null, "fetchDisclaimerStatus", null));
      _defineProperty(this, "_fetchGeneratedCaptions", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (params) {
          // Note: A model instance is currently required for calling collectionActions,
          // so we instantiate and unload a temporary one.
          const temporaryGeneratedCaption = this.store.createRecord('generated-caption');
          const rawResponse = yield temporaryGeneratedCaption.generate({
            topic: params.topic,
            tone: params.tone,
            locale: this.locale.userLocaleCode,
            social_profile_id: this.args.socialProfile.id
          });
          temporaryGeneratedCaption.unloadRecord();
          return rawResponse;
        }
      }), null, "_fetchGeneratedCaptions", null));
      _defineProperty(this, "_processCaptionGeneration", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (rawGeneratedCaptions) {
          try {
            rawGeneratedCaptions.forEach(caption => {
              this.displayedCaptionIds.push(String(caption.id));
            });

            // Note: The post will not exist in the event the caption writer is used from within the
            // media modal
            if (this.args.post) {
              _classPrivateMethodGet(this, _instantiateAssociations, _instantiateAssociations2).call(this);
            }
            this.setFormVisibility(false);
            yield this.aiCredits.fetchUsagesRemaining.linked().perform();
            this.setHasDefaultError(false);
          } catch (error) {
            this.setHasDefaultError(true);
            this.errors.log('_processCaptionGeneration Error: ', error);
          }
        }
      }), null, "_processCaptionGeneration", null));
    }
    willDestroy() {
      super.willDestroy();
      this.timers.forEach(timer => (0, _runloop.cancel)(timer));
      _classPrivateMethodGet(this, _teardownFayeListener, _teardownFayeListener2).call(this);
    }

    /**
     * Attempts to simulate a condition where, while true, a banner is
     * shown in the modal's header section. We use this to add more room
     * for the modal's body section by increasing it's `top` offset
     * value (as it is positioned absolutely).
     */
    get isBannerVisibleInHeader() {
      return this.shouldDisplayNoRemainingCaptions && !this.shouldDisplayCreditPurchase || this.showCreditsDescription && this.isFreeOrLegacyUser || this.remainingCaptionGenerationUsages === 0;
    }
    get postCaptionHasText() {
      return (0, _utils.isPresent)(this.args.post?.caption);
    }
    get isFormDisabled() {
      return this.formDisabled || this.remainingCaptionGenerationUsages === 0;
    }
    get errorObject() {
      return {
        type: 'warning',
        title: this.intl.t('caption_writer.could_not_generate'),
        message: this.intl.t('caption_writer.please_try_again')
      };
    }
    get cacheKey() {
      return `${this.auth.currentUserModel.id}_caption_disclaimer_accepted`;
    }
    get creditCountForPlan() {
      return (this.subscriptions.subscriptionPlan?.numberOfAiCredits ?? 0) + (this.subscriptions.subscription?.additionalAiCredits ?? 0);
    }

    // Note: Keeping the generated captions in the ember-data store allows us to update them via the 'generatedCaptionUpdate'
    // faye event, as well as associate them with the current post (this.args.post)
    get generatedCaptions() {
      return this.store.peekAll('generated-caption').filter(caption => {
        return this.displayedCaptionIds.includes(caption.id);
      });
    }
    get hasError() {
      return this.hasDefaultError;
    }
    get shouldDisplayCreditPurchase() {
      return this.displayCreditPurchase || this.remainingCaptionGenerationUsages === 0 && !this.displayedCaptionIds.length && !this.hasAcknowledgedNoCredits;
    }
    get showCreditsDescription() {
      return !this.shouldDisplayCreditPurchase || this.isFreeOrLegacyUser;
    }
    get showCaptionHistorySection() {
      return (this.navigationState.current === 'root' || this.navigationState.current === 'change-tone') && Boolean(this.generatedCaptions.length);
    }

    // Note: Computed property is a solution for unstable getter https://github.com/emberjs/data/issues/7196
    get hasFailedLoadingAllCaptions() {
      if (!this.generatedCaptions.length) {
        return false;
      }
      if (this.manualFailure) {
        return true;
      }
      return this.generatedCaptions.every(caption => {
        return caption.platformError;
      });
    }
    get isAdvancedUser() {
      return Boolean(this.subscriptions.planType === 'advanced');
    }
    get isEnterpriseSubscription() {
      return this.subscriptions.isEnterpriseSubscription;
    }
    get isFreeOrLegacyUser() {
      return Boolean(this.subscriptions.planType === 'free' || this.auth.currentAccount.isOnLegacyPlan);
    }
    get isFreeOrLegacyUserWithoutCredits() {
      return Boolean(this.isFreeOrLegacyUser && !this.remainingCaptionGenerationUsages);
    }
    get isGeneratingCaptions() {
      return !this.hasError && (this.generateCaptions.isRunning || this.refineCaption.isRunning);
    }
    get hasNoGeneratedCaptions() {
      return !this.hasError && !this.displayedCaptionIds.length && !this.isGeneratingCaptions;
    }
    get shouldDisplayNoRemainingCaptions() {
      return !this.displayedCaptionIds.length && this.remainingCaptionGenerationUsages === 0 && !this.isFreeOrLegacyUser;
    }
    get nextCreditUpdate() {
      return (0, _moment.default)().add(1, 'month').startOf('month').format('MMM D');
    }
    get remainingCaptionGenerationUsages() {
      return this.aiCredits.remainingAICredits;
    }
    get segmentLocation() {
      // Note: no route name available in test context; return empty string
      if (false) {
        return '';
      }
      const {
        currentRouteName
      } = this.router;
      if (currentRouteName.includes('multi')) {
        return 'multi-profile post';
      }
      if (currentRouteName.includes('post')) {
        return 'single-profile post';
      }
      if (currentRouteName.includes('media')) {
        return 'media_item';
      }
      return '';
    }
    get subscriptionPlans() {
      return this.subscriptions.subscriptionPlans;
    }

    // Note: The SocialProfile attributes here should be replaced with the usage of #getSocialProfilePayload in the SegmentService
    // once types have been fixed there: https://github.com/Latermedia/ember-later/pull/11157#discussion_r1084647700
    get defaultSegmentAttributes() {
      const {
        post
      } = this.args;
      if (post) {
        const socialProfileAttributes = {
          nickname: post.get('socialProfile')?.get('nickname') || '',
          industry: post.get('socialProfile')?.get('industry') || '',
          social_profile: post.get('socialProfile')?.get('id') || '',
          business_model: post.get('socialProfile')?.get('businessModel') || '',
          follower_count: post.get('socialProfile')?.get('followedBy') || '',
          profile_type: post.get('socialProfile')?.get('profileType') || '',
          instagram_profile_type: post.get('socialProfile')?.get('instagramProfileType')?.toLowerCase() ?? null
        };
        return {
          ...socialProfileAttributes,
          group_id: this.auth.currentGroup.id,
          location: this.segmentLocation,
          // Note: The post.type will not always be instantiated at this point
          post_type: this.args.post?.type || ''
        };
      }
      return {};
    }
    get showLandingCard() {
      return this.navigationState.current === 'root';
    }
    async setup() {
      await this.subscriptions.getAllSubscriptionPlans();
      _classPrivateMethodGet(this, _setupFayeListener, _setupFayeListener2).call(this);

      // Note: if the post has a caption already, we show the landing page
      if (this.postCaptionHasText) {
        this.updateNavigationState('root');
      } else {
        this.updateNavigationState('generate-new');
      }
      if (this.isFreeOrLegacyUserWithoutCredits) {
        this.displayCreditPurchase = true;
      }
      this.displayedCaptionIds.clear();
      try {
        await Promise.all([this.fetchDisclaimerStatus.perform(), this.aiCredits.fetchUsagesRemaining.perform(), _classPrivateMethodGet(this, _displayPreviouslyGeneratedCaptions, _displayPreviouslyGeneratedCaptions2).call(this)]);
      } catch (e) {
        this.errors.log('Error setting up caption writer', e);
      }
      this.generatedCaptionChangeset = (0, _emberChangeset.Changeset)((0, _trackedBuiltIns.tracked)({
        topic: '',
        tone: undefined,
        targetPostCaptionText: false
      }), (0, _emberChangesetValidations.default)(_generatedCaption.default), _generatedCaption.default);
      this.isLoading = false;
    }
    captionUpdated() {
      if (this.isChangingToneOfCaption && this.generatedCaptionChangeset) {
        this.generatedCaptionChangeset.topic = this.args.post?.get('caption');
      }
    }
    async onInsertComponent() {
      this.segment.track(OPENED_CAPTION_WRITER_SEGMENT_EVENT, this.defaultSegmentAttributes);
      await this.setup();
    }
    closeDisclaimer() {
      this.displayDisclaimer = !this.displayDisclaimer;
      this.args.toggle();
    }
    async hideGeneratedCaption(generatedCaptionId) {
      if (this.args.post) {
        const generatedCaptions = await this.args.post.generatedCaptions;
        this.args.post.set('generatedCaptions', generatedCaptions.filter(caption => caption.id !== generatedCaptionId));
      }
      this.displayedCaptionIds = (0, _trackedBuiltIns.tracked)(this.displayedCaptionIds.filter(id => id !== generatedCaptionId));
      if (!this.displayedCaptionIds.length) {
        // Note: all the captions have been deleted so we show form again
        this.isFormHidden = false;
      }
    }
    onSeamlessCheckoutSuccess() {
      this.aiCredits.fetchUsagesRemaining.perform();
      this.setDisplayCreditPurchase(false);
    }
    setDisplayCreditPurchase(value) {
      this.hasAcknowledgedNoCredits = true;
      this.displayCreditPurchase = value;
    }
    setFormVisibility(isVisible) {
      this.isFormHidden = !isVisible;
    }
    toggleInfoModal() {
      this.displayInfoModal = !this.displayInfoModal;
    }
    setHasDefaultError(value) {
      this.hasDefaultError = value;
    }
    handleNavigateBack() {
      // Note: reset the state stuff
      if (this.navigationState.current === 'root') {
        this.isChangingToneOfCaption = false;
        return;
      }

      // Note: special case
      // TODO: we need real state machine...
      if (this.navigationState.current === 'change-tone.list') {
        this.updateNavigationState('root');
        return;
      }
      if (this.navigationState.last) {
        this.updateNavigationState(this.navigationState.last);
        return;
      }
    }
    onChangeTone() {
      let targetPostCaptionText = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      // TODO: bad - move to landing card component
      if (!this.generatedCaptionChangeset) {
        return;
      }
      this.generatedCaptionChangeset.topic = this.args.post?.get('caption');
      this.generatedCaptionChangeset.targetPostCaptionText = targetPostCaptionText;
      this.isChangingToneOfCaption = true;
      this.setFormVisibility(true);
      this.updateNavigationState('change-tone');
    }
    onGenerateNew() {
      // TODO: bad - move to landing card component
      if (!this.generatedCaptionChangeset) {
        return;
      }
      this.isChangingToneOfCaption = false;
      this.generatedCaptionChangeset.rollback();
      this.setFormVisibility(true);
      this.updateNavigationState('generate-new');
    }
    async onRephrase() {
      let targetPostCaptionText = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      // TODO: bad - move to landing card component
      if (!this.generatedCaptionChangeset) {
        return;
      }
      const temporaryGeneratedCaption = this.store.createRecord('generated-caption', {
        generatedText: this.args.post?.get('caption')
      });
      await this.refineCaption.perform({
        generatedCaption: temporaryGeneratedCaption,
        type: 'rephrase',
        targetPostCaptionText
      });
      temporaryGeneratedCaption.unloadRecord();
      this.updateNavigationState('rephrase-caption');
    }
    updateNavigationState(state) {
      this.navigationState.last = this.navigationState.current;
      this.navigationState.current = state;
    }
  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "aiCredits", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "cache", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "faye", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "locale", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "store", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "displayedCaptionIds", [_trackedBuiltIns.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return new _trackedBuiltIns.TrackedArray([]);
    }
  }), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "displayCreditPurchase", [_trackedBuiltIns.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "displayDisclaimer", [_trackedBuiltIns.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "displayInfoModal", [_trackedBuiltIns.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "formDisabled", [_trackedBuiltIns.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "isChangingToneOfCaption", [_trackedBuiltIns.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "isFormHidden", [_trackedBuiltIns.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "hasDefaultError", [_trackedBuiltIns.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "hasAcknowledgedNoCredits", [_trackedBuiltIns.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "manualFailure", [_trackedBuiltIns.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "isLoading", [_trackedBuiltIns.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return true;
    }
  }), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "navigationState", [_trackedBuiltIns.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return new _trackedBuiltIns.TrackedObject({
        current: 'root',
        last: undefined
      });
    }
  }), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "sortedGeneratedCaptions", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "hasFailedLoadingAllCaptions", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "hasFailedLoadingAllCaptions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "captionUpdated", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "captionUpdated"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onInsertComponent", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onInsertComponent"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeDisclaimer", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeDisclaimer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hideGeneratedCaption", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "hideGeneratedCaption"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onSeamlessCheckoutSuccess", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onSeamlessCheckoutSuccess"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setDisplayCreditPurchase", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setDisplayCreditPurchase"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setFormVisibility", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setFormVisibility"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleInfoModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleInfoModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setHasDefaultError", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setHasDefaultError"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleNavigateBack", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleNavigateBack"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onChangeTone", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onChangeTone"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onGenerateNew", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onGenerateNew"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onRephrase", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onRephrase"), _class.prototype)), _class));
  function _captionIsEmpty2(generatedCaption) {
    return !generatedCaption.platformError && !generatedCaption.platformWarning && !generatedCaption.generatedText;
  }
  async function _displayPreviouslyGeneratedCaptions2() {
    const previouslyGeneratedCaptions = await this.args.post?.get('generatedCaptions');
    previouslyGeneratedCaptions?.forEach(caption => {
      if (!this.displayedCaptionIds.includes(caption.id)) {
        this.displayedCaptionIds.push(caption.id);
      }
    });
  }
  function _displayStillLoadingAlert2() {
    this.alerts.info(this.intl.t('alerts.post.secondary.caption_writer.still_generating'), {
      preventDuplicates: true
    });
  }
  function _displayUsageAlert2() {
    this.alerts.alert(this.intl.t('alerts.post.secondary.caption_writer.limit_reached_message'), {
      title: this.intl.t('alerts.post.secondary.caption_writer.limit_reached_title'),
      preventDuplicates: true
    });
  }
  async function _instantiateAssociations2() {
    this.generatedCaptions.forEach(async generatedCaption => {
      this.args.post?.generatedCaptions.pushObject(generatedCaption);
    });
  }
  function _manuallyCheckCaptions2() {
    const isMissingCaptionUpdates = this.generatedCaptions.length && this.generatedCaptions.every(generatedCaption => _classPrivateMethodGet(this, _captionIsEmpty, _captionIsEmpty2).call(this, generatedCaption));
    if (isMissingCaptionUpdates) {
      _classPrivateMethodGet(this, _displayStillLoadingAlert, _displayStillLoadingAlert2).call(this);
      this.generatedCaptions.forEach(generatedCaption => {
        if (_classPrivateMethodGet(this, _captionIsEmpty, _captionIsEmpty2).call(this, generatedCaption)) {
          this.errors.log('reloadCaptionsOnTimeout Error', {
            generatedCaptionId: generatedCaption.id
          });
          generatedCaption.reload();
        }
      });
    }
    this.formDisabled = false;
  }
  function _onFirstCaptionGenerated2(callback) {
    const hasSingleSuccessfulCaption = this.generatedCaptions.filter(caption => Boolean(caption.generatedText)).length === 1;
    if (hasSingleSuccessfulCaption) {
      callback();
    }
  }
  function _reloadCaptionsOnTimeout2(timeout) {
    const timer = (0, _runloop.later)(this, () => {
      _classPrivateMethodGet(this, _manuallyCheckCaptions, _manuallyCheckCaptions2).call(this);
    }, timeout);
    this.timers.push(timer);
  }
  function _setManualFailure2(timeout) {
    const timer = (0, _runloop.later)(this, () => {
      const hasNoCaptionText = this.generatedCaptions.length && this.generatedCaptions.every(generatedCaption => !generatedCaption.generatedText);
      if (hasNoCaptionText) {
        _classPrivateMethodGet(this, _trackAiGenerationTimeouts, _trackAiGenerationTimeouts2).call(this);
        this.manualFailure = true;
        this.formDisabled = false;
      }
    }, timeout);
    this.timers.push(timer);
  }
  function _setupFayeListener2() {
    this.faye.on(UPDATE_GENERATED_CAPTION_FAYE_EVENT, this, _classPrivateMethodGet(this, _onFayeUpdateCaption, _onFayeUpdateCaption2));
  }
  function _teardownFayeListener2() {
    this.faye.off(UPDATE_GENERATED_CAPTION_FAYE_EVENT, this, _classPrivateMethodGet(this, _onFayeUpdateCaption, _onFayeUpdateCaption2));
  }
  function _onFayeUpdateCaption2(_ref2) {
    let {
      GeneratedCaption
    } = _ref2;
    _classPrivateMethodGet(this, _onFirstCaptionGenerated, _onFirstCaptionGenerated2).call(this, () => {
      let source;
      if (!GeneratedCaption.original_generated_caption_id && !this.isChangingToneOfCaption) {
        source = 'generated-from-scratch';
      } else if (GeneratedCaption.tone) {
        source = 'generated-from-tone-change';
      } else {
        source = 'generated-from-rephrasing';
      }
      this.segment.track(GENERATED_CAPTIONS_SEGMENT_EVENT, {
        ...this.defaultSegmentAttributes,
        source,
        tone: (0, _formatToneForSegment.default)(GeneratedCaption?.tone)
      });
    });
    if (GeneratedCaption.platform_warning) {
      _classPrivateMethodGet(this, _displayStillLoadingAlert, _displayStillLoadingAlert2).call(this);
    }
    if (this.hasFailedLoadingAllCaptions) {
      this.aiCredits.fetchUsagesRemaining.perform();
    }
    this.formDisabled = false;
  }
  function _trackAiGenerationTimeouts2() {
    this.generatedCaptions.forEach(generatedCaption => {
      if (!generatedCaption.platformError) {
        this.segment.track(_segmentEvents.SegmentEventTypes.AiGenerationTimeout, {
          model: 'generated caption',
          id: generatedCaption.id
        });
      }
    });
  }
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, CaptionWriterComponent);
});